import p from"react";import m from"antd/es/flex";var x=r=>{let{children:e,vertical:l=!1,wrap:a="nowrap",justify:t="center",align:i="normal",flex:n="normal",gap:o,style:f={}}=r;return p.createElement(m,{vertical:l,wrap:a,justify:t,align:i,flex:n,gap:o,style:f},e)};export{x as default};
//# sourceMappingURL=index.js.map
